import gql from 'graphql-tag'
import { applicationFragment } from './fragments'

export const applicationQuery = gql`
  query GetApplication($organizationID: ID!, $applicationID: ID!) {
    application(
      organizationID: $organizationID
      applicationID: $applicationID
    ) {
      ...Application
    }
  }

  ${applicationFragment}
`
export const aggregationsQuery = gql`
  query ApplicationAggregations(
    $organizationID: ID!
    $filterText: String
    $quickFilter: String
    $tags: [String]
    $technologies: [String]
    $languages: [String]
    $servers: [String]
    $compliance: [String]
    $openVulnSeverities: [String]
    $customMetadata: [CustomMetadataFilter]
    $environment: [String]
    $appImportances: [String]
    $scores: [String]
  ) {
    applicationAggregations(
      organizationID: $organizationID
      filters: {
        tags: $tags
        technologies: $technologies
        languages: $languages
        servers: $servers
        compliance: $compliance
        openVulnSeverities: $openVulnSeverities
        filterText: $filterText
        quickFilter: $quickFilter
        customMetadata: $customMetadata
        environment: $environment
        appImportances: $appImportances
        scores: $scores
      }
    ) {
      scores {
        count
        key
      }
      servers {
        count
        key {
          name
          id
        }
      }
      languages {
        count
        key {
          id
          label
        }
      }
      technologies {
        count
        key
      }
      tags {
        count
        key
      }
      compliance {
        count
        key {
          name
          id
        }
      }
      openVulnSeverities {
        count
        key {
          id
          label
        }
      }
      environment {
        count
        key {
          id
          label
        }
      }
      appImportances {
        count
        key {
          id
          label
        }
      }
    }
  }
`
export const quickFiltersQuery = gql`
  query ApplicationQuickFilters(
    $organizationID: ID!
    $filterText: String
    $tags: [String]
    $technologies: [String]
    $languages: [String]
    $servers: [String]
    $compliance: [String]
    $openVulnSeverities: [String]
    $customMetadata: [CustomMetadataFilter]
    $environment: [String]
    $appImportances: [String]
    $scores: [String]
  ) {
    applicationQuickFilters(
      organizationID: $organizationID
      filters: {
        tags: $tags
        technologies: $technologies
        languages: $languages
        servers: $servers
        compliance: $compliance
        openVulnSeverities: $openVulnSeverities
        filterText: $filterText
        customMetadata: $customMetadata
        environment: $environment
        appImportances: $appImportances
        scores: $scores
      }
    ) {
      id
      name
      count
    }
  }
`
export const collectionQuery = gql`
  query ApplicationsPage(
    $offset: Int!
    $limit: Int!
    $organizationID: ID!
    $orderBy: ApplicationOrder!
    $filterText: String
    $quickFilter: String
    $tags: [String]
    $technologies: [String]
    $languages: [String]
    $servers: [String]
    $compliance: [String]
    $openVulnSeverities: [String]
    $customMetadata: [CustomMetadataFilter]
    $environment: [String]
    $appImportances: [String]
    $scores: [String]
  ) {
    applications(
      offset: $offset
      limit: $limit
      organizationID: $organizationID
      orderBy: $orderBy
      filters: {
        tags: $tags
        technologies: $technologies
        servers: $servers
        languages: $languages
        compliance: $compliance
        openVulnSeverities: $openVulnSeverities
        filterText: $filterText
        quickFilter: $quickFilter
        customMetadata: $customMetadata
        environment: $environment
        appImportances: $appImportances
        scores: $scores
      }
    ) {
      items {
        ...Application
      }
      total
    }
  }

  ${applicationFragment}
`
export const metadataQuery = gql`
  query GetMetadataAggregations(
    $organizationID: ID!
    $filterText: String
    $quickFilter: String
    $tags: [String]
    $technologies: [String]
    $languages: [String]
    $servers: [String]
    $compliance: [String]
    $openVulnSeverities: [String]
    $customMetadata: [CustomMetadataFilter]
    $environment: [String]
    $appImportances: [String]
    $scores: [String]
  ) {
    customApplicationAggregations(
      organizationID: $organizationID
      filters: {
        tags: $tags
        technologies: $technologies
        languages: $languages
        servers: $servers
        compliance: $compliance
        openVulnSeverities: $openVulnSeverities
        filterText: $filterText
        quickFilter: $quickFilter
        customMetadata: $customMetadata
        environment: $environment
        appImportances: $appImportances
        scores: $scores
      }
    ) {
      id
      fieldType
      label
      buckets {
        count
        key {
          id
          value
          subfieldValues {
            fieldType
            value
          }
        }
      }
    }
  }
`
